var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 142,
    viewBox: "0 0 107 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.616,
    width: 105.759,
    height: 17.6641,
    rx: 8.83207,
    fill: "white",
    stroke: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 61.7184,
    width: 105.759,
    height: 17.6641,
    rx: 8.83207,
    fill: "white",
    stroke: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 94.5672,
    width: 105.759,
    height: 17.6641,
    rx: 8.83207,
    fill: "white",
    stroke: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2929 28.6174C99.3056 28.618 99.3189 28.6188 99.3323 28.6199L99.2929 29.5669V28.6174ZM99.2929 28.6174V28.6139H99.129C91.9802 28.5862 86.6511 26.7766 82.6706 24.1028C78.6868 21.4269 76.0243 17.8654 74.2439 14.2922C72.4626 10.7171 71.5693 7.1394 71.122 4.45133C70.8985 3.10847 70.7869 1.9908 70.7312 1.2108C70.7034 0.820889 70.6895 0.515607 70.6826 0.309042C70.6792 0.205768 70.6774 0.127193 70.6766 0.0750802L70.6759 0.016987L70.6758 0.00324442L99.2929 28.6174ZM73.3478 43.4939C71.5626 47.0775 70.6465 50.652 70.1758 53.3773C69.705 50.652 68.789 47.0775 67.0037 43.4939C65.1648 39.8026 62.3987 36.0925 58.2403 33.2991C55.3308 31.3447 51.7541 29.8489 47.3621 29.116C51.7541 28.3832 55.3308 26.8874 58.2403 24.9329C62.3987 22.1396 65.1648 18.4295 67.0037 14.7382C68.7892 11.1542 69.7052 7.57918 70.1759 4.85376C70.6468 7.57918 71.5632 11.1542 73.3489 14.7382C75.1881 18.4295 77.9545 22.1396 82.113 24.933C85.0225 26.8872 88.5989 28.383 92.9905 29.1159C88.598 29.8486 85.021 31.3446 82.1112 33.2991C77.9528 36.0925 75.1867 39.8026 73.3478 43.4939Z",
    fill: "white",
    stroke: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4443 112.233C66.457 112.233 66.4703 112.234 66.4837 112.235L66.4443 113.182V112.233ZM66.4443 112.233V112.229H66.2804C59.1316 112.202 53.8025 110.392 49.822 107.718C45.8381 105.042 43.1757 101.481 41.3953 97.9075C39.614 94.3324 38.7206 90.7547 38.2733 88.0666C38.0499 86.7237 37.9383 85.6061 37.8826 84.8261C37.8547 84.4362 37.8409 84.1309 37.834 83.9243C37.8305 83.821 37.8288 83.7425 37.828 83.6903L37.8272 83.6323L37.8271 83.6185L66.4443 112.233ZM40.4992 127.109C38.7139 130.693 37.7979 134.267 37.3271 136.993C36.8564 134.267 35.9403 130.693 34.1551 127.109C32.3162 123.418 29.5501 119.708 25.3917 116.914C22.4822 114.96 18.9054 113.464 14.5135 112.731C18.9054 111.999 22.4822 110.503 25.3917 108.548C29.5501 105.755 32.3162 102.045 34.1551 98.3534C35.9406 94.7694 36.8566 91.1944 37.3273 88.469C37.7982 91.1944 38.7145 94.7695 40.5003 98.3535C42.3395 102.045 45.1058 105.755 49.2644 108.548C52.1738 110.502 55.7503 111.998 60.1418 112.731C55.7494 113.464 52.1723 114.96 49.2626 116.914C45.1042 119.708 42.3381 123.418 40.4992 127.109Z",
    fill: "white",
    stroke: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.ee06a090f6ab4da4c4743ee2f1762dc9.svg";
export { ForwardRef as ReactComponent };